import './CashinClosingModeButton.less';

import clsx from 'clsx';
import i18n from '../../../common/i18n';
import React, { FC, forwardRef, useRef } from 'react';
import InfoIcon from '../../../icons/InfoIcon';
import { useCashinClosingButton } from './useCashinHooks';

interface CashinClosingModeButtonProps {
    portalPadding?: boolean;
    ticketId: string;
    transactionActive?: boolean;
    handleClick: (value: any) => any;
    handleClickInfo: (value: any) => any;
}

const CashinClosingModeButton: FC<CashinClosingModeButtonProps> = forwardRef<
    HTMLButtonElement,
    CashinClosingModeButtonProps
>(({ portalPadding, ticketId, handleClick, handleClickInfo }, ref) => {
    const { hidden } = useCashinClosingButton(ticketId);
    const cashinClosingInfoButtonRef = useRef(null);

    return hidden ? null : (
        <div
            className={clsx('flex-center full-width', { 'px-15': !portalPadding, 'pl-15': portalPadding })}
            onClick={e => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <button
                ref={ref}
                className={clsx('cashin-closing-btn px-20', {})}
                title={i18n('nui.ticketus.cashin.closing.offer')}
                data-atid="cashin-closing-btn"
                data-testid="cashin-closing-btn"
                data-ticket-id={ticketId}
                onClick={handleClick(ref)}
            >
                {i18n('nui.ticketus.cashin.closing')}
            </button>
            <button
                ref={cashinClosingInfoButtonRef}
                className={clsx('cashin-closing-info-btn flex-center', {})}
                title={i18n('nui.ticketus.cashin.closing.info')}
                data-atid="cashin-closing-info-btn"
                onClick={handleClickInfo(cashinClosingInfoButtonRef)}
            >
                <InfoIcon fill="#ffffff" opacity={0.8} width={20} height={20} />
            </button>
        </div>
    );
});

export default CashinClosingModeButton;
